module.exports = __webpack_public_path__ + "img/product1.01a76c18.png";